// extracted by mini-css-extract-plugin
export default {"footer":"css_footer__ssiOd"};